export default __webpack_public_path__ + "static/media/OGJ-Type-Design-Sequel-Sans-Book-Obl-Head.1d4dab41.woff";